import { useQuery } from 'react-query';

import {
  NEWSLETTERS_KEY,
  NewsletterDetailsParams,
  NewsletterDetailsResponse,
  getNewsletterDetails,
} from '@utils/backend-api/newsletters';

export default function useNewsletterDetailByIds({ newsletter_ids }: NewsletterDetailsParams) {
  const { data, isLoading } = useQuery<NewsletterDetailsResponse>(
    [NEWSLETTERS_KEY],
    async () => await getNewsletterDetails({ newsletter_ids }),
    {
      enabled: newsletter_ids.length > 0,
    }
  );

  return { newsletters: data?.newsletters, isLoadingNewsletters: isLoading };
}
